<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">NOVEDADES</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <template v-for="(n,$index) in novedades">
                    <v-card class="mx-auto">
                        <v-list class="purple lighten-2 white--text" two-line>
                            <v-list-tile>
                                <v-list-tile-avatar>
                                    <v-icon dark size="42" class="mr-3"> calendar_today</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title class="headline">{{ n.tit }}</v-list-tile-title>
                                    <v-list-tile-subtitle>{{ n.created_at | fecha }}</v-list-tile-subtitle>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-container>
                            <v-layout>
                                <v-flex>
                                    {{ n.obs }}
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="n.img">
                                <v-img :src="n.img" class="grey lighten-2">
                                    <template slot="placeholder">
                                        <v-layout fill-height align-center justify-center ma-0>
                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                        </v-layout>
                                    </template>
                                </v-img>
                            </v-layout>
                        </v-container>
                    </v-card>
                    <br>
                </template>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import mixinNovedad from '../mixins/novedad';
    import fecha from '../filters/fecha-db'

    export default {
        name: "novedades",
        filters: {fecha},
        mixins: [mixinNovedad],
        data() {
            return {
                novedades: []
            }
        },
        mounted() {
            this.getNovedades();
        },
        methods: {
            getNovedades() {
                this.novedadIndex(1, r => {
                    this.novedades = r.data;
                }, err => console.error(err))
            },
            isOdd(num) {
                return ((num % 2) === 1);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/novedades.vue